import { PartyInfo } from "@mpa/toolbox/models/Party";

import { SubmitAction } from "../../../action/Action";
import Button from "../../../components/Button/Button";
import Centered from "../../../components/Centered";
import Form from "../../../components/form/Form";
import type { PhoneFieldProps } from "../../../components/form/PhoneField";
import PhoneField from "../../../components/form/PhoneField";
import type { TextFieldProps } from "../../../components/form/TextField";
import TextField from "../../../components/form/TextField";
import useField from "../../../components/form/useField";
import Grid, { GridColspan } from "../../../components/Grid";
import { PartyAttributeType } from "../../../enums/PartyAttributeType";

type PartyEditorProps = {
    infos: PartyInfo[];
    onDone: (infos: PartyInfo[]) => unknown;
};

export function PartyEditor(props: PartyEditorProps) {
    const { infos, onDone } = props;
    const firstnameField = useField<TextFieldProps>({
        value: PartyInfo.find(infos, PartyAttributeType.Firstname)?.value,
        label: "Prénom",
        required: true,
    });
    const lastnameField = useField<TextFieldProps>({
        value: PartyInfo.find(infos, PartyAttributeType.Lastname)?.value,
        label: "Nom",
    });
    const emailField = useField<TextFieldProps>({
        value: PartyInfo.find(infos, PartyAttributeType.Email)?.value,
        label: "Adresse email",
        type: "email",
    });
    const phoneField = useField<PhoneFieldProps>({
        value: PartyInfo.find(infos, PartyAttributeType.Phone)?.value,
        label: "Téléphone",
    });
    const onSubmit = async () => {
        let next = infos;
        next = withUniqueInfo(next, PartyAttributeType.Firstname, firstnameField.validate());
        next = withUniqueInfo(next, PartyAttributeType.Lastname, lastnameField.validate());
        next = withUniqueInfo(next, PartyAttributeType.Email, emailField.validate());
        next = withUniqueInfo(next, PartyAttributeType.Phone, phoneField.validate());
        await onDone(next);
    };
    return (
        <Form onSubmit={onSubmit}>
            <Grid columns={2} gap={4}>
                <TextField {...firstnameField.props} />
                <TextField {...lastnameField.props} />
                <GridColspan columns={2}>
                    <TextField {...emailField.props} />
                </GridColspan>
                <GridColspan columns={2}>
                    <PhoneField {...phoneField.props} />
                </GridColspan>
                <GridColspan columns={2}>
                    <Centered>
                        <Button label="Valider" action={SubmitAction} />
                    </Centered>
                </GridColspan>
            </Grid>
        </Form>
    );
}

function withUniqueInfo(infos: PartyInfo[], type: PartyAttributeType, value: string | null) {
    const next = infos.filter((info) => info.type !== type);
    if (value) {
        const info = new PartyInfo();
        info.type = type;
        info.value = value;
        next.push(info);
    }
    return next;
}
